import React, { FC } from 'react';
import styles from './search_filters_radio_content.module.scss';

type Props = {
  dataTestId?: string;
};

export const SearchFiltersRadioContent: FC<Props> = ({
  children,
  dataTestId,
}) => (
  <div className={styles.container} data-test-id={dataTestId}>
    {children}
  </div>
);
